export default __webpack_public_path__ + "static/media/thumbnail.985fa6be.png";